import { kAgentAssistantRouterApiBasePath } from '@/constants/constants-api-paths'
import { kPaxtonAppApiRESTBaseUrl } from '@/constants/constants-links'
import { kErrorCodeAuthError } from '@/constants/constants-error-codes'
import { getAuth } from 'firebase/auth'
import { nanoid } from 'nanoid'
import { ApiError } from '@/util/errors/api-error'
import { getFileNameFromContentDisposition } from '@/util/api/content-disposition'

export type WritingSampleReferenceContent = {
  blob: Blob
  fileName: string | null
}

export async function fetchWritingSampleReferenceContent(referenceId: string, matterId: string): Promise<WritingSampleReferenceContent> {
  const token = await getAuth().currentUser?.getIdToken()
  if (!token) throw new Error(kErrorCodeAuthError)

  const queryParams = new URLSearchParams({ matter_id: matterId })
  const apiUrl = `${kPaxtonAppApiRESTBaseUrl()}${kAgentAssistantRouterApiBasePath}/references/${encodeURIComponent(
    referenceId
  )}/writing-sample-content?${queryParams.toString()}`

  const response = await fetch(apiUrl, {
    method: 'GET',
    headers: {
      'X-Transaction-Id': nanoid(),
      Authorization: `Bearer ${token}`,
    },
  })

  if (!response.ok) {
    const detail = await response.text().catch(() => response.statusText)
    throw new ApiError(response.status, `Fetch writing sample content failed - status: ${response.status}, detail: ${detail}`)
  }

  return {
    blob: await response.blob(),
    fileName: getFileNameFromContentDisposition(response.headers.get('Content-Disposition')),
  }
}
